import { nullableFilters } from '../../common/customHooks/useFiltersRestoreNew';
import { FarmOptionsTypes } from './types';

export const checkForNullableFilters = (
  tableName: string,
  filterTitle: string,
  newSelection: FarmOptionsTypes.Selection[],
) => {
  const newFilterColumns = newSelection.map((item) => item.key);
  if (
    newFilterColumns.length === 0 &&
    nullableFilters[tableName]?.includes(filterTitle)
  ) {
    return ['null'];
  }
  return newFilterColumns;
};

export default {
  checkForNullableFilters,
};
